var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 123,
    viewBox: "0 0 147 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8828 43.8066V101.433L73.0849 122.319L125.292 101.433V43.8066H20.8828Z",
    fill: "#C9C1AE",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0859 122.319L125.291 101.435V43.8066H73.0859V122.319Z",
    fill: "#FFFFF6",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9643 0.507812L73.0848 11.2984L52.2037 0.507812L0 27.481L20.8795 38.2683L0 49.0589L52.2037 76.0255L73.0848 65.2415L93.9643 76.0255L146.17 49.0589L125.288 38.2683L146.17 27.481L93.9643 0.507812Z",
    fill: "#F5E9D1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0849 11.2988L20.8828 38.2671L73.0849 65.2419L125.292 38.2671L73.0849 11.2988Z",
    fill: "#C9C1AE",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyOrder);
export default __webpack_public_path__ + "static/media/emptyOrder.644545c95a916ab27b4011b60529daab.svg";
export { ForwardRef as ReactComponent };